import { colors } from '@/theme/tokens';
import {
  BlockOutlinedIcon,
  EditIcon,
  CancelIcon,
  CheckCircleIcon,
  BuildsIcon,
  DonutLargeIcon,
  DriveFileMoveIcon,
  ErrorIcon,
  EventAvailable,
  EventBusy,
  EventOutlinedIcon,
  HelpIcon,
  PlayCircleFilledWhiteIcon,
  ReleasesIcon,
  ScheduleIcon,
  StagesIcon,
  SuitesFilledIcon,
  TestsFilledIcon,
} from '@/ui/primitives/icons';
import type { MetricCardItem } from '@/features/metrics/components/statusMetricCards';
import type { MetricsScope } from '@/features/metrics/metricsHelpers';
import type { SvgIconComponent } from '@/ui/primitives';

export const resolveStackedStatusCardIcon = (
  statusId: string,
  scope: MetricsScope,
): SvgIconComponent => {
  if (statusId === 'draft') return EditIcon;
  if (statusId === 'planned') return EventOutlinedIcon;
  if (statusId === 'ready') return EventAvailable;
  if (statusId === 'overdue') return EventBusy;
  if (statusId === 'released') return ReleasesIcon;
  if (statusId === 'passed' || statusId === 'completed' || statusId === 'success') {
    return CheckCircleIcon;
  }
  if (statusId === 'failed') return CancelIcon;
  if (statusId === 'errored') return ErrorIcon;
  if (statusId === 'running') return PlayCircleFilledWhiteIcon;
  if (statusId === 'queued') return ScheduleIcon;
  if (statusId === 'none') return DonutLargeIcon;
  if (statusId === 'skipped') return BlockOutlinedIcon;
  if (statusId === 'untested') return HelpIcon;
  if (statusId === 'total' && scope === 'executionRun') return PlayCircleFilledWhiteIcon;
  if (statusId === 'total' && scope === 'pipeline') return BuildsIcon;
  if (statusId === 'total' && scope === 'stage') return DriveFileMoveIcon;
  if (statusId === 'total' && scope === 'job') return StagesIcon;
  if (statusId === 'total' && scope === 'suite') return SuitesFilledIcon;
  if (statusId === 'total' && scope === 'test') return TestsFilledIcon;
  return DonutLargeIcon;
};

export const resolveGenericStatusCardIcon = (statusId: string): SvgIconComponent => {
  if (statusId === 'draft') return EditIcon;
  if (statusId === 'planned') return EventOutlinedIcon;
  if (statusId === 'ready') return EventAvailable;
  if (statusId === 'overdue') return EventBusy;
  if (statusId === 'released') return ReleasesIcon;
  if (statusId === 'passed' || statusId === 'completed' || statusId === 'success') {
    return CheckCircleIcon;
  }
  if (statusId === 'failed') return CancelIcon;
  if (statusId === 'errored') return ErrorIcon;
  if (statusId === 'running') return PlayCircleFilledWhiteIcon;
  if (statusId === 'queued') return ScheduleIcon;
  if (statusId === 'none' || statusId === 'total') return DonutLargeIcon;
  if (statusId === 'skipped') return BlockOutlinedIcon;
  if (statusId === 'untested') return HelpIcon;
  return DonutLargeIcon;
};

export const resolveStackedStatusCardIconColor = (
  statusTone: MetricCardItem['statusTone'],
): string => {
  if (statusTone === 'success') return colors.light.success;
  if (statusTone === 'error') return colors.light.danger;
  if (statusTone === 'warning') return colors.light.warning;
  if (statusTone === 'brown') return colors.light.brown;
  if (statusTone === 'primary') return colors.light.primary;
  if (statusTone === 'info') return colors.light.info;
  return colors.light.neutral;
};
